import React, { ButtonHTMLAttributes, forwardRef } from "react";
import { theme } from "../../theme/theme";
import "./iconButton.css";

export interface IconButtonProps
    extends ButtonHTMLAttributes<HTMLButtonElement> {
    circle?: boolean;
    uiSize?: number;
    uiColor?: "green";
    uiActiveColor?: string;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    (props, ref) => {
        const {
            circle,
            uiSize = 24,
            uiColor,
            uiActiveColor,
            className,
            style,
            disabled,
            children,
            ...other
        } = props;

        const color =
            uiColor === "green" ? theme.colors.info : theme.colors.primary;
        const activeBg = uiActiveColor || theme.colors.lightGrayText;

        const classes = [
            "icon-button",
            circle ? "icon-button--circle" : "",
            disabled ? "icon-button--disabled" : "",
            className,
        ]
            .filter(Boolean)
            .join(" ");

        const cssVars = { ...style } as React.CSSProperties;
        (cssVars as any)["--icon-button-size"] = `${uiSize}px`;
        (cssVars as any)["--icon-button-color"] = color;
        (cssVars as any)["--icon-button-active-bg"] = activeBg;
        (cssVars as any)["--icon-button-icon-size"] = `${uiSize}px`;

        if (circle) {
            (cssVars as any)["--icon-button-border-width"] = `${uiSize * 0.1}px`;
            (cssVars as any)["--icon-button-inner-size"] = `${uiSize * 0.7}px`;
        }

        return (
            <button
                {...other}
                ref={ref}
                className={classes}
                style={cssVars}
                disabled={disabled}
                aria-disabled={disabled ? true : undefined}
            >
                {children}
            </button>
        );
    }
);

IconButton.displayName = "IconButton";

export default IconButton;
